import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useEffect, useState } from "react";
import { getCourseLessons } from "../../../../models/course";

const useStyles = makeStyles(() => ({
  inner: {
    minWidth: 700,
  },
}));

export default function SelectLessonTable({
  courseCode,
  courseVer,
  onCheck,
  isChecked,
  isDisabled,
}: {
  courseCode: string;
  courseVer: number;
  onCheck: (id: number) => void;
  isChecked: (id: number) => boolean;
  isDisabled: (id: number) => boolean;
}) {
  const classes = useStyles();

  const [lessons, setLessons] = useState<
    import("../../../../models/lesson").Lesson[]
  >([]);
  useEffect(() => {
    getCourseLessons(courseCode, courseVer).then(setLessons, console.error);
  }, [courseCode, courseVer]);

  return (
    <>
      <Divider />
      <div className={classes.inner}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>配信順</TableCell>
              <TableCell>レッスン名</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lessons.map((x, i) => (
              <TableRow hover={true} key={x.lessonID}>
                <TableCell>
                  <Checkbox
                    checked={isChecked(x.lessonID)}
                    onChange={() => onCheck(x.lessonID)}
                    color="primary"
                    disabled={isDisabled(x.lessonID)}
                  />
                </TableCell>
                <TableCell>{i + 1}</TableCell>
                <TableCell>{x.lessonName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
}
